export default __webpack_public_path__ + "static/media/icons - Edit.11e7f4a9.svg";